import * as _ from "lodash";
import * as angular from "angular";
import { BuildingService } from "../services/building.service";

export class BuildingDataProvider {
    private __app_type: string;
    private service: BuildingService;
    private $q: any;
    private modelsUtils: any;
    public localStorageService: any;

    private searchPromise: any;
    public effort: object | null = null;
    public error = false;
    public scrollLoading = false;
    public loading = true;
    public countError = false;
    private isLeaderView: boolean;
    public buildings = [];

    constructor(
        __app_type: string,
        BuildingService: BuildingService,
        $q: any,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.service = BuildingService;
        this.__app_type = __app_type;
        this.isLeaderView = this.__app_type === "LEADER";
        this.modelsUtils = ModelsUtils;
    }

    clearAll(): void {
        this.searchPromise = null;
        this.buildings.splice(0, this.buildings.length);
    }

    getAll(): Promise<any> {
        this.error = false;

        this.loading = true;

        const deferred = this.$q.defer();
        if (this.searchPromise) {
            this.searchPromise.resolve("user cancelled");
        }
        this.searchPromise = this.$q.defer();

        this.service.all({}).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    for (let i = 0; i < json.data.length; i++) {
                        let building = this.modelsUtils.building(json.data[i]);
                        this.buildings.push(building);
                    }
                    deferred.resolve(this.buildings);
                } else {
                    deferred.reject();
                }
                this.loading = false;
            },
            (error: any) => {
                if (error.status > -1) {
                    this.error = true;
                    this.loading = false;
                }
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    update(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.update(data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getBuilding(bid: number | string): Promise<any> {
        const deferred = this.$q.defer();
        this.service.info({ id: bid }).then((response: object) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(this.modelsUtils.building(json.data));
            }
            deferred.reject();
        });
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("BuildingDataProvider", BuildingDataProvider);
